"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComparisonAvailable = exports.removeDivergentDateItems = exports.hasSameDateDimension = exports.transformMeasureBuckets = exports.getItemsLocalIdentifiers = exports.getAllMeasuresShowOnSecondaryAxis = exports.removeShowOnSecondaryAxis = exports.setMeasuresShowOnSecondaryAxis = exports.limitNumberOfMeasuresInBuckets = exports.noColumnsAndHasOneMeasure = exports.noRowsAndHasOneMeasure = exports.getFilteredMeasuresForStackedCharts = exports.hasDerivedBucketItems = exports.findDerivedBucketItem = exports.findDerivedBucketItems = exports.findMasterBucketItems = exports.findMasterBucketItem = exports.removeAllDerivedMeasures = exports.removeAllArithmeticMeasuresFromDerived = exports.getFirstMasterWithDerived = exports.getBucketsByNames = exports.findBucket = exports.hasBucket = exports.applyUiConfig = exports.getMainDateItem = exports.getFistDateItem = exports.getFistDateItemWithMultipleDates = exports.getDateItemsWithMultipleDates = exports.getDateItems = exports.getAllAttributeItemsWithPreference = exports.getAllAttributeItems = exports.getAllCategoriesAttributeItems = exports.getAttributeItemsWithoutStacks = exports.getAttributeItems = exports.getViewItems = exports.getStackItems = exports.getBucketItemsWithExcludeByType = exports.getMeasureItems = exports.getFirstAttribute = exports.getFirstValidMeasure = exports.getAllMeasures = exports.getMeasuresFromMdObject = exports.getTotalsFromBucket = exports.removeDuplicateBucketItems = exports.getAllItemsByType = exports.getPreferredBucketItems = exports.getBucketItemsByType = exports.getItemsFromBuckets = exports.getBucketItems = exports.getItemsCount = exports.generateBucketTitleId = exports.setBucketTitles = exports.getComparisonTypeFromFilters = exports.getDateFilter = exports.isNotDateBucketItem = exports.isDateBucketItem = exports.filterOutIncompatibleArithmeticMeasures = exports.keepOnlyMasterAndDerivedMeasuresOfType = exports.filterOutArithmeticMeasuresFromDerived = exports.filterOutDerivedMeasures = exports.getDerivedTypesFromArithmeticMeasure = exports.isDerivedBucketItem = exports.sanitizeFilters = exports.isRankingFilter = exports.isActiveMeasureValueFilter = exports.isMeasureValueFilter = exports.isAttributeFilter = exports.isFiltersBucketItem = exports.isDateFilter = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var uniq_1 = tslib_1.__importDefault(require("lodash/uniq"));
var uniqBy_1 = tslib_1.__importDefault(require("lodash/uniqBy"));
var negate_1 = tslib_1.__importDefault(require("lodash/negate"));
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var every_1 = tslib_1.__importDefault(require("lodash/every"));
var forEach_1 = tslib_1.__importDefault(require("lodash/forEach"));
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var without_1 = tslib_1.__importDefault(require("lodash/without"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var Visualization_1 = require("../interfaces/Visualization");
var bucket_1 = require("../constants/bucket");
var translations_1 = require("./translations");
function isDateFilter(filter) {
    return !!filter && filter.attribute === Visualization_1.DATE_DATASET_ATTRIBUTE;
}
exports.isDateFilter = isDateFilter;
function isFiltersBucketItem(filter) {
    return !!filter && filter.attribute === Visualization_1.DATE_DATASET_ATTRIBUTE;
}
exports.isFiltersBucketItem = isFiltersBucketItem;
function isAttributeFilter(filter) {
    var filterAsAttributeFilter = filter;
    return (!!filter &&
        filterAsAttributeFilter.attribute !== Visualization_1.DATE_DATASET_ATTRIBUTE &&
        filterAsAttributeFilter.attribute !== undefined);
}
exports.isAttributeFilter = isAttributeFilter;
function isMeasureValueFilter(filter) {
    return !!filter && !!filter.measureLocalIdentifier;
}
exports.isMeasureValueFilter = isMeasureValueFilter;
function isActiveMeasureValueFilter(filter) {
    if (!isMeasureValueFilter(filter)) {
        return false;
    }
    return !!filter.condition;
}
exports.isActiveMeasureValueFilter = isActiveMeasureValueFilter;
function isRankingFilter(filter) {
    var filterAsRankingFilter = filter;
    return (!!filter &&
        typeof filterAsRankingFilter.measure === "string" &&
        typeof filterAsRankingFilter.operator === "string" &&
        typeof filterAsRankingFilter.value === "number");
}
exports.isRankingFilter = isRankingFilter;
function sanitizeFilters(newReferencePoint) {
    var attributeBucketItems = getAllAttributeItems(newReferencePoint.buckets);
    var measureBucketItems = getAllMeasureItems(newReferencePoint.buckets);
    newReferencePoint.filters = newReferencePoint.filters || {
        localIdentifier: "filters",
        items: [],
    };
    var filteredFilters = newReferencePoint.filters.items.filter(function (filterBucketItem) {
        var filter = filterBucketItem.filters[0];
        if (isAttributeFilter(filter) || isDateFilter(filter)) {
            if (filterBucketItem.autoCreated === false) {
                return true;
            }
            return attributeBucketItems.some(function (attributeBucketItem) { return attributeBucketItem.attribute === filter.attribute; });
        }
        else if (isMeasureValueFilter(filter)) {
            if (attributeBucketItems.length === 0) {
                return false;
            }
            return measureBucketItems.some(function (measureBucketItem) {
                return measureBucketItem.localIdentifier === filter.measureLocalIdentifier;
            });
        }
        else if (isRankingFilter(filter)) {
            if (attributeBucketItems.length === 0) {
                return false;
            }
            var hasValidMeasure = measureBucketItems.some(function (measureBucketItem) { return measureBucketItem.localIdentifier === filter.measure; });
            var hasValidAttributes = !filter.attributes ||
                filter.attributes.every(function (localIdentifier) {
                    return attributeBucketItems.some(function (attributeBucketItem) { return attributeBucketItem.localIdentifier === localIdentifier; });
                });
            return hasValidMeasure && hasValidAttributes;
        }
        return false;
    });
    return tslib_1.__assign(tslib_1.__assign({}, newReferencePoint), { filters: tslib_1.__assign(tslib_1.__assign({}, newReferencePoint.filters), { items: filteredFilters }) });
}
exports.sanitizeFilters = sanitizeFilters;
function isDerivedBucketItem(measureItem) {
    return !!measureItem.masterLocalIdentifier;
}
exports.isDerivedBucketItem = isDerivedBucketItem;
function isArithmeticBucketItem(bucketItem) {
    return !!bucketItem.operandLocalIdentifiers;
}
function isDerivedOfTypeBucketItem(measureItem, derivedType) {
    if (!isDerivedBucketItem(measureItem)) {
        return false;
    }
    return measureItem.overTimeComparisonType === derivedType;
}
function findDerivedTypesReferencedByArithmeticMeasure(measure, allMeasures, visitedMeasures) {
    return measure.operandLocalIdentifiers.reduce(function (types, operandIdentifier) {
        if (operandIdentifier === null || visitedMeasures.has(operandIdentifier)) {
            return types;
        }
        var operand = findMeasureByLocalIdentifier(operandIdentifier, allMeasures);
        if (operand === undefined) {
            return types;
        }
        if (isArithmeticBucketItem(operand)) {
            visitedMeasures.add(operandIdentifier);
            findDerivedTypesReferencedByArithmeticMeasure(operand, allMeasures, visitedMeasures).forEach(function (type) { return types.add(type); });
        }
        else if (isDerivedBucketItem(operand) && !types.has(operand.overTimeComparisonType)) {
            types.add(operand.overTimeComparisonType);
        }
        return types;
    }, new Set());
}
/**
 * Get array of unique over time comparison types used in ancestors of the provided arithmetic measure.
 *
 * @param measure - the (possibly) arithmetic measure
 * @param buckets - all buckets
 * @returns empty array if there are no derived measures in the arithmetic measure ancestors, empty array if provided
 * measure is not arithmetic, array of unique {@link OverTimeComparisonType} of derived ancestor measures found in arithmetic
 * measure tree.
 */
function getDerivedTypesFromArithmeticMeasure(measure, buckets) {
    if (!isArithmeticBucketItem(measure)) {
        return [];
    }
    var allMeasures = flatMap_1.default(buckets, function (bucket) { return bucket.items; });
    var overTimeComparisonTypes = findDerivedTypesReferencedByArithmeticMeasure(measure, allMeasures, new Set());
    return Array.from(overTimeComparisonTypes);
}
exports.getDerivedTypesFromArithmeticMeasure = getDerivedTypesFromArithmeticMeasure;
function filterOutDerivedMeasures(measures) {
    return measures.filter(function (measure) { return !isDerivedBucketItem(measure); });
}
exports.filterOutDerivedMeasures = filterOutDerivedMeasures;
function isArithmeticMeasureFromDerived(measure, buckets) {
    return getDerivedTypesFromArithmeticMeasure(measure, buckets).length > 0;
}
function filterOutArithmeticMeasuresFromDerived(measures, buckets) {
    return measures.filter(function (measure) { return !isArithmeticMeasureFromDerived(measure, buckets); });
}
exports.filterOutArithmeticMeasuresFromDerived = filterOutArithmeticMeasuresFromDerived;
function isArithmeticMeasureFromDerivedOfTypeOnly(measure, buckets, derivedType) {
    var arithmeticMeasureDerivedTypes = getDerivedTypesFromArithmeticMeasure(measure, buckets);
    return arithmeticMeasureDerivedTypes.length === 1 && arithmeticMeasureDerivedTypes[0] === derivedType;
}
function keepOnlyMasterAndDerivedMeasuresOfType(measures, derivedType) {
    return measures.filter(function (measure) { return !isDerivedBucketItem(measure) || isDerivedOfTypeBucketItem(measure, derivedType); });
}
exports.keepOnlyMasterAndDerivedMeasuresOfType = keepOnlyMasterAndDerivedMeasuresOfType;
function filterOutIncompatibleArithmeticMeasures(measures, buckets, derivedOfTypeToKeep) {
    return measures.filter(function (measure) {
        return !isArithmeticBucketItem(measure) ||
            !isArithmeticMeasureFromDerived(measure, buckets) ||
            isArithmeticMeasureFromDerivedOfTypeOnly(measure, buckets, derivedOfTypeToKeep);
    });
}
exports.filterOutIncompatibleArithmeticMeasures = filterOutIncompatibleArithmeticMeasures;
function isDateBucketItem(bucketItem) {
    return !!bucketItem && bucketItem.type === bucket_1.DATE;
}
exports.isDateBucketItem = isDateBucketItem;
exports.isNotDateBucketItem = negate_1.default(isDateBucketItem);
function getDateFilter(filtersBucket) {
    if (!filtersBucket) {
        return null;
    }
    var dateFiltersInclEmpty = flatMap_1.default(filtersBucket.items, function (filterItem) {
        var _a;
        var filters = (_a = filterItem.filters) !== null && _a !== void 0 ? _a : [];
        return filters.find(isDateFilter);
    });
    var dateFilters = compact_1.default(dateFiltersInclEmpty);
    return dateFilters.length ? dateFilters[0] : null;
}
exports.getDateFilter = getDateFilter;
function getComparisonTypeFromFilters(filtersBucket) {
    if (isEmpty_1.default(filtersBucket)) {
        return sdk_ui_1.OverTimeComparisonTypes.NOTHING;
    }
    var dateFilter = getDateFilter(filtersBucket);
    return !isEmpty_1.default(dateFilter) && dateFilter.overTimeComparisonType
        ? dateFilter.overTimeComparisonType
        : sdk_ui_1.OverTimeComparisonTypes.NOTHING;
}
exports.getComparisonTypeFromFilters = getComparisonTypeFromFilters;
function bucketSupportsSubtitle(visualizationType, bucketLocalIdentifier) {
    if (visualizationType === sdk_ui_1.VisualizationTypes.HEADLINE) {
        return true;
    }
    if (visualizationType === sdk_ui_1.VisualizationTypes.SCATTER) {
        return bucketLocalIdentifier !== sdk_ui_1.BucketNames.ATTRIBUTE;
    }
    if (visualizationType === sdk_ui_1.VisualizationTypes.BUBBLE) {
        return bucketLocalIdentifier !== sdk_ui_1.BucketNames.VIEW;
    }
    if (visualizationType === sdk_ui_1.VisualizationTypes.COMBO) {
        return bucketLocalIdentifier !== sdk_ui_1.BucketNames.VIEW;
    }
    if (visualizationType === sdk_ui_1.VisualizationTypes.BULLET) {
        return bucketLocalIdentifier !== sdk_ui_1.BucketNames.VIEW;
    }
    if (visualizationType === sdk_ui_1.VisualizationTypes.PUSHPIN) {
        return (bucketLocalIdentifier !== sdk_ui_1.BucketNames.LOCATION && bucketLocalIdentifier !== sdk_ui_1.BucketNames.SEGMENT);
    }
    return false;
}
function setBucketTitles(referencePoint, visualizationType, intl) {
    var buckets = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets;
    var updatedUiConfig = cloneDeep_1.default(referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.uiConfig);
    forEach_1.default(buckets, function (bucket) {
        var _a, _b, _c, _d;
        var localIdentifier = (_a = bucket.localIdentifier) !== null && _a !== void 0 ? _a : "";
        // skip disabled buckets
        if (!((_d = (_c = (_b = updatedUiConfig === null || updatedUiConfig === void 0 ? void 0 : updatedUiConfig.buckets) === null || _b === void 0 ? void 0 : _b[localIdentifier]) === null || _c === void 0 ? void 0 : _c.enabled) !== null && _d !== void 0 ? _d : false)) {
            return;
        }
        if (bucketSupportsSubtitle(visualizationType, localIdentifier)) {
            var subtitleId = generateBucketSubtitleId(localIdentifier, visualizationType);
            var subtitle = translations_1.getTranslation(subtitleId, intl);
            set_1.default(updatedUiConfig, [bucket_1.BUCKETS, localIdentifier, "subtitle"], subtitle);
        }
        var titleId = generateBucketTitleId(localIdentifier, visualizationType);
        var title = translations_1.getTranslation(titleId, intl);
        set_1.default(updatedUiConfig, [bucket_1.BUCKETS, localIdentifier, "title"], title);
    });
    return updatedUiConfig;
}
exports.setBucketTitles = setBucketTitles;
function generateBucketTitleId(localIdentifier, visualizationType) {
    return "dashboard.bucket." + localIdentifier + "_title." + visualizationType;
}
exports.generateBucketTitleId = generateBucketTitleId;
function generateBucketSubtitleId(localIdentifier, visualizationType) {
    return "dashboard.bucket." + localIdentifier + "_subtitle." + visualizationType;
}
function getItemsCount(buckets, localIdentifier) {
    return getBucketItems(buckets, localIdentifier).length;
}
exports.getItemsCount = getItemsCount;
function getBucketItems(buckets, localIdentifier) {
    var _a, _b;
    return (_b = (_a = buckets.find(function (bucket) { return bucket.localIdentifier === localIdentifier; })) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : [];
}
exports.getBucketItems = getBucketItems;
// return bucket items matching localIdentifiers from any bucket
function getItemsFromBuckets(buckets, localIdentifiers, types) {
    return localIdentifiers.reduce(function (bucketItems, localIdentifier) {
        return bucketItems.concat(types
            ? getBucketItemsByType(buckets, localIdentifier, types)
            : getBucketItems(buckets, localIdentifier));
    }, []);
}
exports.getItemsFromBuckets = getItemsFromBuckets;
function getBucketItemsByType(buckets, localIdentifier, types) {
    var itemsOfType = [];
    var bucketItems = getBucketItems(buckets, localIdentifier);
    bucketItems.forEach(function (item) {
        if (includes_1.default(types, item.type)) {
            itemsOfType.push(item);
        }
    });
    return itemsOfType;
}
exports.getBucketItemsByType = getBucketItemsByType;
function getPreferredBucketItems(buckets, preference, type) {
    var _a;
    var bucket = getPreferredBucket(buckets, preference, type);
    return (_a = bucket === null || bucket === void 0 ? void 0 : bucket.items) !== null && _a !== void 0 ? _a : [];
}
exports.getPreferredBucketItems = getPreferredBucketItems;
function getPreferredBucket(buckets, preference, type) {
    return preference.reduce(function (result, preference) {
        if (result) {
            return result;
        }
        return buckets.find(function (bucket) {
            var _a;
            var preferenceMatch = bucket.localIdentifier === preference;
            var typeMatch = every_1.default((_a = bucket === null || bucket === void 0 ? void 0 : bucket.items) !== null && _a !== void 0 ? _a : [], function (item) { return type.indexOf(item.type) !== -1; });
            return preferenceMatch && typeMatch;
        });
    }, undefined);
}
function getAllBucketItemsByType(bucket, types) {
    return bucket.items.reduce(function (resultItems, item) {
        if (includes_1.default(types, item.type)) {
            resultItems.push(item);
        }
        return resultItems;
    }, []);
}
function getAllItemsByType(buckets, types) {
    return buckets.reduce(function (items, bucket) { return tslib_1.__spreadArrays(items, getAllBucketItemsByType(bucket, types)); }, []);
}
exports.getAllItemsByType = getAllItemsByType;
function removeDuplicateBucketItems(buckets) {
    var usedIdentifiersMap = {};
    return buckets.map(function (bucket) {
        var filteredBucketItems = bucket.items.filter(function (bucketItem) {
            var isDuplicate = usedIdentifiersMap[bucketItem.localIdentifier];
            usedIdentifiersMap[bucketItem.localIdentifier] = true;
            return !isDuplicate;
        });
        return filteredBucketItems.length === bucket.items.length
            ? bucket
            : tslib_1.__assign(tslib_1.__assign({}, bucket), { items: filteredBucketItems });
    });
}
exports.removeDuplicateBucketItems = removeDuplicateBucketItems;
function getTotalsFromBucket(buckets, bucketName) {
    var _a;
    var selectedBucket = buckets.find(function (bucket) { return bucket.localIdentifier === bucketName; });
    return (_a = selectedBucket === null || selectedBucket === void 0 ? void 0 : selectedBucket.totals) !== null && _a !== void 0 ? _a : [];
}
exports.getTotalsFromBucket = getTotalsFromBucket;
function getUniqueAttributes(buckets) {
    var attributes = getAllItemsByType(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]);
    return uniqBy_1.default(attributes, function (attribute) { return attribute === null || attribute === void 0 ? void 0 : attribute.attribute; });
}
function getMeasuresFromMdObject(insight) {
    if (!insight) {
        return [];
    }
    return sdk_model_1.bucketsMeasures(sdk_model_1.insightBuckets(insight), sdk_model_1.isSimpleMeasure);
}
exports.getMeasuresFromMdObject = getMeasuresFromMdObject;
function getAllMeasures(buckets) {
    return getAllItemsByType(buckets, [bucket_1.METRIC]);
}
exports.getAllMeasures = getAllMeasures;
function getFirstValidMeasure(buckets) {
    var measures = getAllMeasures(buckets);
    var validMeasures = measures.filter(isValidMeasure);
    return validMeasures[0] || null;
}
exports.getFirstValidMeasure = getFirstValidMeasure;
function isValidMeasure(measure) {
    if (isArithmeticBucketItem(measure)) {
        return measure.operandLocalIdentifiers.every(function (operandLocalIdentifier) { return operandLocalIdentifier !== null; });
    }
    return true;
}
function getFirstAttribute(buckets) {
    return getUniqueAttributes(buckets)[0] || null;
}
exports.getFirstAttribute = getFirstAttribute;
function getMeasureItems(buckets) {
    var preference = [sdk_ui_1.BucketNames.MEASURES, sdk_ui_1.BucketNames.SECONDARY_MEASURES, sdk_ui_1.BucketNames.TERTIARY_MEASURES];
    var preferredMeasures = preference.reduce(function (acc, pref) {
        var prefBucketItems = getPreferredBucketItems(buckets, [pref], [bucket_1.METRIC]);
        return tslib_1.__spreadArrays(acc, prefBucketItems);
    }, []);
    // if no preferred items are found, return all available items
    if (isEmpty_1.default(preferredMeasures)) {
        return getAllMeasures(buckets);
    }
    return preferredMeasures;
}
exports.getMeasureItems = getMeasureItems;
function getBucketItemsWithExcludeByType(buckets, excludedBucket, type) {
    var includedBuckets = buckets.filter(function (bucket) { return !includes_1.default(excludedBucket, bucket.localIdentifier); });
    return getAllItemsByType(includedBuckets, type);
}
exports.getBucketItemsWithExcludeByType = getBucketItemsWithExcludeByType;
function getStackItems(buckets, itemTypes) {
    var _a;
    if (itemTypes === void 0) { itemTypes = [bucket_1.ATTRIBUTE]; }
    var preferredStacks = getPreferredBucket(buckets, [sdk_ui_1.BucketNames.STACK, sdk_ui_1.BucketNames.SEGMENT], itemTypes);
    return (_a = preferredStacks === null || preferredStacks === void 0 ? void 0 : preferredStacks.items) !== null && _a !== void 0 ? _a : [];
}
exports.getStackItems = getStackItems;
function getViewItems(buckets, itemTypes) {
    var _a;
    if (itemTypes === void 0) { itemTypes = [bucket_1.ATTRIBUTE]; }
    var preferredStacks = getPreferredBucket(buckets, [sdk_ui_1.BucketNames.VIEW], itemTypes);
    return (_a = preferredStacks === null || preferredStacks === void 0 ? void 0 : preferredStacks.items) !== null && _a !== void 0 ? _a : [];
}
exports.getViewItems = getViewItems;
function getAttributeItems(buckets) {
    return getAllAttributeItemsWithPreference(buckets, [
        sdk_ui_1.BucketNames.LOCATION,
        sdk_ui_1.BucketNames.VIEW,
        sdk_ui_1.BucketNames.TREND,
    ]);
}
exports.getAttributeItems = getAttributeItems;
function getAttributeItemsWithoutStacks(buckets, itemTypes) {
    if (itemTypes === void 0) { itemTypes = [bucket_1.ATTRIBUTE]; }
    return getAttributeItems(buckets).filter(function (attribute) {
        return !includes_1.default(getStackItems(buckets, itemTypes), attribute);
    });
}
exports.getAttributeItemsWithoutStacks = getAttributeItemsWithoutStacks;
function getAllCategoriesAttributeItems(buckets) {
    var stackItemsWithDate = getStackItems(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]);
    return getAttributeItems(buckets).filter(function (attribute) {
        return !includes_1.default(stackItemsWithDate, attribute);
    });
}
exports.getAllCategoriesAttributeItems = getAllCategoriesAttributeItems;
function getAllAttributeItems(buckets) {
    return getAllItemsByType(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]);
}
exports.getAllAttributeItems = getAllAttributeItems;
function getAllMeasureItems(buckets) {
    return getAllItemsByType(buckets, [bucket_1.METRIC]);
}
// get all attributes from buckets, but items from preferred buckets are first
function getAllAttributeItemsWithPreference(buckets, preference) {
    var preferredAttributes = preference.reduce(function (acc, pref) {
        var _a;
        var prefBucket = getPreferredBucket(buckets, [pref], [bucket_1.ATTRIBUTE, bucket_1.DATE]);
        return tslib_1.__spreadArrays(acc, ((_a = prefBucket === null || prefBucket === void 0 ? void 0 : prefBucket.items) !== null && _a !== void 0 ? _a : []));
    }, []);
    var allBucketNames = buckets.map(function (bucket) { return bucket === null || bucket === void 0 ? void 0 : bucket.localIdentifier; });
    var otherBucketNames = allBucketNames.filter(function (bucketName) { return !includes_1.default(preference, bucketName); });
    var allOtherAttributes = otherBucketNames.reduce(function (attributes, bucketName) {
        return attributes.concat(getBucketItemsByType(buckets, bucketName, [bucket_1.ATTRIBUTE, bucket_1.DATE]));
    }, []);
    return tslib_1.__spreadArrays(preferredAttributes, allOtherAttributes);
}
exports.getAllAttributeItemsWithPreference = getAllAttributeItemsWithPreference;
function getDateItems(buckets) {
    return getAttributeItemsWithoutStacks(buckets).filter(isDateBucketItem);
}
exports.getDateItems = getDateItems;
function getDateItemsWithMultipleDates(buckets) {
    return getAttributeItemsWithoutStacks(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]).filter(isDateBucketItem);
}
exports.getDateItemsWithMultipleDates = getDateItemsWithMultipleDates;
function getFistDateItemWithMultipleDates(buckets) {
    var dateItems = getDateItemsWithMultipleDates(buckets);
    return dateItems[0];
}
exports.getFistDateItemWithMultipleDates = getFistDateItemWithMultipleDates;
function getFistDateItem(buckets) {
    var dateItems = getDateItems(buckets);
    return dateItems[0];
}
exports.getFistDateItem = getFistDateItem;
function getMainDateItem(dateItems) {
    // first item for now, can be replaced by item matching the dimension of date filter in future
    return dateItems[0];
}
exports.getMainDateItem = getMainDateItem;
function hasItemsAboveLimit(bucket, itemsLimit) {
    var masterBucketItems = filterOutDerivedMeasures(bucket.items);
    return masterBucketItems.length > itemsLimit;
}
function applyItemsLimit(bucket, itemsLimit) {
    if (itemsLimit !== undefined && hasItemsAboveLimit(bucket, itemsLimit)) {
        var newBucket = cloneDeep_1.default(bucket);
        newBucket.items = newBucket.items.slice(0, itemsLimit);
        return newBucket;
    }
    return bucket;
}
function applyUiConfigOnBucket(bucket, bucketUiConfig) {
    return applyItemsLimit(bucket, bucketUiConfig === null || bucketUiConfig === void 0 ? void 0 : bucketUiConfig.itemsLimit);
}
function applyUiConfig(referencePoint) {
    var buckets = referencePoint.buckets;
    var uiConfig = referencePoint.uiConfig.buckets;
    var newBuckets = buckets.map(function (bucket) {
        return applyUiConfigOnBucket(bucket, uiConfig[bucket.localIdentifier]);
    });
    set_1.default(referencePoint, "buckets", newBuckets);
    return referencePoint;
}
exports.applyUiConfig = applyUiConfig;
function hasBucket(buckets, localIdentifier) {
    return buckets.some(function (bucket) { return bucket.localIdentifier === localIdentifier; });
}
exports.hasBucket = hasBucket;
function findBucket(buckets, localIdentifier) {
    return buckets.find(function (bucket) { return (bucket === null || bucket === void 0 ? void 0 : bucket.localIdentifier) === localIdentifier; });
}
exports.findBucket = findBucket;
function getBucketsByNames(buckets, names) {
    return buckets.filter(function (bucket) { return includes_1.default(names, bucket === null || bucket === void 0 ? void 0 : bucket.localIdentifier); });
}
exports.getBucketsByNames = getBucketsByNames;
function getFirstMasterWithDerived(measureItems) {
    var masters = filterOutDerivedMeasures(measureItems);
    var chosenMaster = masters[0];
    return measureItems.filter(function (measureItem) {
        return measureItem.masterLocalIdentifier === chosenMaster.localIdentifier ||
            measureItem === chosenMaster;
    });
}
exports.getFirstMasterWithDerived = getFirstMasterWithDerived;
function removeAllArithmeticMeasuresFromDerived(extendedReferencePoint) {
    var originalBuckets = cloneDeep_1.default(extendedReferencePoint.buckets);
    forEach_1.default(extendedReferencePoint.buckets, function (bucket) {
        bucket.items = filterOutArithmeticMeasuresFromDerived(bucket.items, originalBuckets);
    });
    return extendedReferencePoint;
}
exports.removeAllArithmeticMeasuresFromDerived = removeAllArithmeticMeasuresFromDerived;
function removeAllDerivedMeasures(extendedReferencePoint) {
    forEach_1.default(extendedReferencePoint.buckets, function (bucket) {
        bucket.items = filterOutDerivedMeasures(bucket.items);
    });
    return extendedReferencePoint;
}
exports.removeAllDerivedMeasures = removeAllDerivedMeasures;
function findMasterBucketItem(derivedBucketItem, bucketItems) {
    return bucketItems.find(function (item) { return item.localIdentifier === derivedBucketItem.masterLocalIdentifier; });
}
exports.findMasterBucketItem = findMasterBucketItem;
function findMasterBucketItems(bucketItems) {
    return bucketItems.filter(function (measure) { return !isDerivedBucketItem(measure); });
}
exports.findMasterBucketItems = findMasterBucketItems;
function findDerivedBucketItems(masterBucketItem, bucketItems) {
    return bucketItems.filter(function (measure) { return measure.masterLocalIdentifier === masterBucketItem.localIdentifier; });
}
exports.findDerivedBucketItems = findDerivedBucketItems;
function findDerivedBucketItem(masterBucketItem, bucketItems) {
    return bucketItems.find(function (bucketItem) { return bucketItem.masterLocalIdentifier === masterBucketItem.localIdentifier; });
}
exports.findDerivedBucketItem = findDerivedBucketItem;
function hasDerivedBucketItems(masterBucketItem, buckets) {
    return buckets.some(function (bucket) {
        return bucket.items.some(function (bucketItem) { return bucketItem.masterLocalIdentifier === masterBucketItem.localIdentifier; });
    });
}
exports.hasDerivedBucketItems = hasDerivedBucketItems;
function getFilteredMeasuresForStackedCharts(buckets) {
    var hasStacks = getStackItems(buckets, [bucket_1.ATTRIBUTE, bucket_1.DATE]).length > 0;
    if (hasStacks) {
        var limitedBuckets = limitNumberOfMeasuresInBuckets(buckets, 1);
        return getMeasureItems(limitedBuckets);
    }
    return getMeasureItems(buckets);
}
exports.getFilteredMeasuresForStackedCharts = getFilteredMeasuresForStackedCharts;
function noRowsAndHasOneMeasure(buckets) {
    var measuresBucket = sdk_model_1.bucketsFind(buckets, sdk_ui_1.BucketNames.MEASURES);
    var measures = measuresBucket ? sdk_model_1.bucketItems(measuresBucket) : [];
    var rowsBucket = sdk_model_1.bucketsFind(buckets, sdk_ui_1.BucketNames.VIEW);
    var rows = rowsBucket ? sdk_model_1.bucketItems(rowsBucket) : [];
    var hasOneMeasure = measures.length === 1;
    var hasRows = rows.length > 0;
    return Boolean(hasOneMeasure && !hasRows);
}
exports.noRowsAndHasOneMeasure = noRowsAndHasOneMeasure;
function noColumnsAndHasOneMeasure(buckets) {
    var measuresBucket = sdk_model_1.bucketsFind(buckets, sdk_ui_1.BucketNames.MEASURES);
    var measures = measuresBucket ? sdk_model_1.bucketItems(measuresBucket) : [];
    var columnsBucket = sdk_model_1.bucketsFind(buckets, sdk_ui_1.BucketNames.STACK);
    var columns = columnsBucket ? sdk_model_1.bucketItems(columnsBucket) : [];
    var hasOneMeasure = measures.length === 1;
    var hasColumn = columns.length > 0;
    return hasOneMeasure && !hasColumn;
}
exports.noColumnsAndHasOneMeasure = noColumnsAndHasOneMeasure;
function limitNumberOfMeasuresInBuckets(buckets, measuresLimitCount, tryToSelectDerivedWithMaster) {
    if (tryToSelectDerivedWithMaster === void 0) { tryToSelectDerivedWithMaster = false; }
    var allMeasures = getAllMeasures(buckets);
    var selectedMeasuresLocalIdentifiers = [];
    // try to select measures one per bucket
    buckets.forEach(function (bucket) {
        var currentBucketMeasures = getAllBucketItemsByType(bucket, [bucket_1.METRIC]);
        if (currentBucketMeasures.length === 0) {
            return;
        }
        selectedMeasuresLocalIdentifiers = getLimitedMeasuresLocalIdentifiers(currentBucketMeasures, 1, allMeasures, measuresLimitCount, tryToSelectDerivedWithMaster, selectedMeasuresLocalIdentifiers);
    });
    // if it was not possible to select all measures one per bucket then limit them globally
    if (selectedMeasuresLocalIdentifiers.length < measuresLimitCount) {
        selectedMeasuresLocalIdentifiers = getLimitedMeasuresLocalIdentifiers(allMeasures, measuresLimitCount, allMeasures, measuresLimitCount, tryToSelectDerivedWithMaster, selectedMeasuresLocalIdentifiers);
    }
    return pruneBucketMeasureItems(buckets, selectedMeasuresLocalIdentifiers);
}
exports.limitNumberOfMeasuresInBuckets = limitNumberOfMeasuresInBuckets;
function getLimitedMeasuresLocalIdentifiers(measures, measuresLimitCount, allMeasures, allMeasuresLimitCount, tryToSelectDerivedWithMaster, alreadySelectedMeasures) {
    var selectedMeasures = alreadySelectedMeasures;
    // try to select measures one by one together with their dependencies
    measures.forEach(function (measure) {
        if (selectedMeasures.length - alreadySelectedMeasures.length === measuresLimitCount) {
            return;
        }
        var measureDependencies = getDependenciesLocalIdentifiers(measure, allMeasures);
        var measureWithDependencies = tslib_1.__spreadArrays([measure.localIdentifier], measureDependencies);
        if (tryToSelectDerivedWithMaster) {
            var derivedMeasures = getDerivedLocalIdentifiers(measure, allMeasures);
            var masterDerivedAndDependencies = tslib_1.__spreadArrays(measureWithDependencies, derivedMeasures);
            selectedMeasures = tryToSelectMeasures(masterDerivedAndDependencies, selectedMeasures, allMeasuresLimitCount);
        }
        selectedMeasures = tryToSelectMeasures(measureWithDependencies, selectedMeasures, allMeasuresLimitCount);
    });
    return selectedMeasures;
}
function getDerivedLocalIdentifiers(measure, allMeasures) {
    var derivedMeasures = findDerivedBucketItems(measure, allMeasures);
    return derivedMeasures.map(function (derivedMeasure) { return derivedMeasure.localIdentifier; });
}
function findMeasureByLocalIdentifier(localIdentifier, measures) {
    return measures.find(function (measure) { return measure.localIdentifier === localIdentifier; });
}
function getDependenciesLocalIdentifiers(measure, allMeasures) {
    var directDependencies = [];
    if (measure.masterLocalIdentifier) {
        directDependencies.push(measure.masterLocalIdentifier);
    }
    if (measure.operandLocalIdentifiers) {
        measure.operandLocalIdentifiers
            .filter(function (operandLocalIdentifier) { return operandLocalIdentifier !== null; })
            .forEach(function (operandLocalIdentifier) {
            var operandMeasure = findMeasureByLocalIdentifier(operandLocalIdentifier, allMeasures);
            if (operandMeasure !== undefined) {
                directDependencies.push(operandLocalIdentifier);
            }
        });
    }
    var indirectDependencies = [];
    directDependencies.forEach(function (dependencyLocalIdentifier) {
        var dependencyMeasure = findMeasureByLocalIdentifier(dependencyLocalIdentifier, allMeasures);
        var dependenciesOfDependency = getDependenciesLocalIdentifiers(dependencyMeasure, allMeasures);
        indirectDependencies.push.apply(indirectDependencies, dependenciesOfDependency);
    });
    return uniq_1.default(tslib_1.__spreadArrays(directDependencies, indirectDependencies));
}
function tryToSelectMeasures(measures, alreadySelectedMeasures, limit) {
    var measuresToBePlaced = without_1.default.apply(void 0, tslib_1.__spreadArrays([measures], alreadySelectedMeasures));
    if (measuresToBePlaced.length <= limit - alreadySelectedMeasures.length) {
        return tslib_1.__spreadArrays(alreadySelectedMeasures, measuresToBePlaced);
    }
    return alreadySelectedMeasures;
}
function pruneBucketMeasureItems(buckets, measureLocalIdentifiersToBeKept) {
    return buckets.map(function (bucket) {
        var prunedItems = bucket.items.filter(function (item) {
            return measureLocalIdentifiersToBeKept.indexOf(item.localIdentifier) > -1 || item.type !== bucket_1.METRIC;
        });
        return tslib_1.__assign(tslib_1.__assign({}, bucket), { items: prunedItems });
    });
}
function isShowOnSecondaryAxis(item) {
    var _a;
    return (_a = item === null || item === void 0 ? void 0 : item.showOnSecondaryAxis) !== null && _a !== void 0 ? _a : false;
}
function setMeasuresShowOnSecondaryAxis(items, value) {
    return items.map(function (item) {
        var _a;
        return (tslib_1.__assign(tslib_1.__assign({}, item), (_a = {}, _a[bucket_1.SHOW_ON_SECONDARY_AXIS] = value, _a)));
    });
}
exports.setMeasuresShowOnSecondaryAxis = setMeasuresShowOnSecondaryAxis;
function removeShowOnSecondaryAxis(items) {
    return setMeasuresShowOnSecondaryAxis(items, null);
}
exports.removeShowOnSecondaryAxis = removeShowOnSecondaryAxis;
function getAllMeasuresShowOnSecondaryAxis(buckets) {
    return getAllItemsByType(buckets, [bucket_1.METRIC]).filter(isShowOnSecondaryAxis);
}
exports.getAllMeasuresShowOnSecondaryAxis = getAllMeasuresShowOnSecondaryAxis;
function getItemsLocalIdentifiers(items) {
    return items.map(function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item.localIdentifier) !== null && _a !== void 0 ? _a : ""; });
}
exports.getItemsLocalIdentifiers = getItemsLocalIdentifiers;
exports.transformMeasureBuckets = function (measureBucketItemsLimits, buckets) {
    var unusedMeasures = [];
    var newBuckets = measureBucketItemsLimits.map(function (_a) {
        var localIdentifier = _a.localIdentifier, itemsLimit = _a.itemsLimit;
        var preferredBucketLocalIdentifiers = localIdentifier === sdk_ui_1.BucketNames.MEASURES
            ? [sdk_ui_1.BucketNames.MEASURES, sdk_ui_1.BucketNames.SIZE]
            : localIdentifier === sdk_ui_1.BucketNames.SECONDARY_MEASURES
                ? [sdk_ui_1.BucketNames.SECONDARY_MEASURES, sdk_ui_1.BucketNames.COLOR]
                : [localIdentifier];
        var preferredBucketItems = getPreferredBucketItems(buckets, preferredBucketLocalIdentifiers, [
            bucket_1.METRIC,
        ]);
        var measuresToBePlaced = preferredBucketItems.splice(0, itemsLimit);
        if (measuresToBePlaced.length === 0) {
            return {
                localIdentifier: localIdentifier,
                items: unusedMeasures.splice(0, itemsLimit),
            };
        }
        unusedMeasures = tslib_1.__spreadArrays(unusedMeasures, preferredBucketItems);
        return {
            localIdentifier: localIdentifier,
            items: measuresToBePlaced,
        };
    });
    return newBuckets.map(function (bucket, bucketIndex) {
        var bucketItemsLimit = measureBucketItemsLimits[bucketIndex].itemsLimit;
        var freeSlotsCount = bucketItemsLimit - bucket.items.length;
        if (freeSlotsCount === 0) {
            return bucket;
        }
        return tslib_1.__assign(tslib_1.__assign({}, bucket), { items: tslib_1.__spreadArrays(bucket.items, unusedMeasures.splice(0, freeSlotsCount)) });
    });
};
exports.hasSameDateDimension = function (dateItem, referenceDateItem) {
    if (isDateBucketItem(dateItem) && isDateBucketItem(referenceDateItem)) {
        return sdk_model_1.areObjRefsEqual(dateItem.dateDatasetRef, referenceDateItem.dateDatasetRef);
    }
    return false;
};
exports.removeDivergentDateItems = function (viewItems, mainDateItem) {
    return viewItems.filter(function (item) { return exports.isNotDateBucketItem(item) || exports.hasSameDateDimension(item, mainDateItem); });
};
var getDateFilterRef = function (filters) {
    var _a;
    var dateFilter = (_a = filters === null || filters === void 0 ? void 0 : filters.items) === null || _a === void 0 ? void 0 : _a.find(isFiltersBucketItem);
    if (!dateFilter) {
        return undefined;
    }
    return dateFilter.dateDatasetRef;
};
exports.isComparisonAvailable = function (buckets, filters) {
    var itemsFromBucket = buckets.reduce(function (acc, bucket) { return acc.concat(bucket.items); }, []);
    var bucketDateItems = itemsFromBucket.filter(isDateBucketItem);
    var areDateBucketItemsEmpty = bucketDateItems.length === 0;
    var dateFilterRef = getDateFilterRef(filters);
    if (areDateBucketItemsEmpty) {
        return true;
    }
    return bucketDateItems.some(function (bucketDateItem) {
        return sdk_model_1.areObjRefsEqual(bucketDateItem.dateDatasetRef, dateFilterRef);
    });
};
//# sourceMappingURL=bucketHelper.js.map